// UI-SPEC §"Component Inventory" §Form / §Typography labels — sans 400
// (regular weight, NEVER a heavier sans bump), uppercase, tracking-wide.
'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@/shared/lib/utils';

const labelVariants = cva(
  // sans 400 + uppercase + tracking-wide is the UI-SPEC label treatment.
  'text-sm font-normal uppercase tracking-wide leading-snug peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-foreground',
);

const Label = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
